module.exports = __webpack_public_path__ + "img/ec.a12f3b4.svg";